import { render, staticRenderFns } from "./OrderComboboxSearch.vue?vue&type=template&id=36fda49e&scoped=true&%23contentTemplate=%7B%7D&"
import script from "./OrderComboboxSearch.vue?vue&type=script&lang=js&"
export * from "./OrderComboboxSearch.vue?vue&type=script&lang=js&"
import style0 from "./OrderComboboxSearch.vue?vue&type=style&index=0&id=36fda49e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fda49e",
  null
  
)

export default component.exports